/**
 * @description scope
 * @author duanjun
 */

export default class Scope<T> {
    public _model: T;
    public _initModel: T;
    constructor(model: T) {
        this._model = model;
        this._initModel = model;
    }
    public get model() {
        return this._model;
    }
    public set model(model: T) {
        this._model = model;
    }
    public reset() {
        this._model = this._initModel;
    }
}
